import React, { useEffect, useRef, useState } from "react";
import styles from "../faq.module.scss";
import Tag from "@Pages/PropertyPage/components/AmenitiesSection/components/Tag";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import Button from "@Components/Button";

interface AmenitiesListProps {
  amenitiesData: any[];
  dataTestId?: string;
  isDesktop?: boolean;
}

const AmenitiesList: React.FC<AmenitiesListProps> = ({ amenitiesData, dataTestId, isDesktop }) => {
  const [showAll, setShowAll] = React.useState(false);
  const [numberOfAmenities, setNumberOfAmenities] = useState(isDesktop ? 5 : 6);
  const displayedAmenities = showAll ? amenitiesData : amenitiesData.slice(0, numberOfAmenities);
  const amenitiesContainerRef = useRef<HTMLDivElement | null>(null);
  const getNumberOfAmenities = (length: number) => {
    if (isDesktop) {
      return length > 1072 ? 5 : 4;
    }
    return 6;
  };
  useEffect(() => {
    if (amenitiesContainerRef.current) {
      const length = amenitiesContainerRef.current.clientWidth;
      setNumberOfAmenities(getNumberOfAmenities(length));
    }
  }, [amenitiesData]);

  return (
    <>
      <div
        className={formatClassNames(styles.amenities, amenitiesData.length > 0 && styles.active)}
      >
        <div className={styles.heading}>{`Amenities (${amenitiesData.length})`}</div>
        <div ref={amenitiesContainerRef} className={styles.amenitiesContainer}>
          {displayedAmenities.map((amenity: any, idx: number) => {
            const amenityName = amenity.name ?? amenity.type;
            const amenityType = `${amenity.name} ${amenity.type}`;
            return (
              <div key={`${amenityName}-${idx}`} className={styles.innerAmenities}>
                <Tag
                  dataTestId={dataTestId}
                  key={amenityName}
                  icon={amenityType}
                  value={amenityName}
                  isNewVersion
                  index={idx}
                  roomTypeSection={false}
                  isDesktop={isDesktop}
                  highlightText={amenity.highlightText || null}
                >
                  {amenityName}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
      {amenitiesData.length > numberOfAmenities && (
        <div className={styles.amenitiesViewBtn}>
          <Button
            variant={!showAll ? "showMore" : "showLess"}
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? "View less" : `View all (${amenitiesData.length - numberOfAmenities})`}
          </Button>
        </div>
      )}
    </>
  );
};

export default wrapperHOC(AmenitiesList, {
  componentName: "FAQs-AmenitiesList",
  showForChina: true,
  showForWhiteLable: true,
});
